
<div *ngFor="let pageInfo of (docPageProxiesObs | async); trackBy: trackByIdx">
  <ss-pdf-page
    [pageInfo]="pageInfo"
  >
  </ss-pdf-page>
  
</div>